var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center text-lg"},[(!_vm.content)?_c('default-null-html'):_c('div',{staticClass:"ping",class:_vm.quality,attrs:{"title":_vm.pingString}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }